import React, { useState, useEffect, useRef, useMemo } from "react";

function LocationSelectChain({ roots, onDeepestChange, locationWord }) {
    const [selectedIds, setSelectedIds] = useState([]);
    const lastReported = useRef(null);

    const getNodeByPath = (path) => {
        let node = roots.find((x) => x.id === path[0]);
        if (!node) return null;

        for (let i = 1; i < path.length; i++) {
            node = node.sublocations?.find((x) => x.id === path[i]);
            if (!node) return null;
        }
        return node;
    };

    // 🧠 PRE-CALCULATE LEVELS (important)
    const levels = useMemo(() => {
        const list = [];
        let level = 0;

        while (true) {
            let options;

            if (level === 0) {
                options = roots;
            } else {
                const parent = getNodeByPath(selectedIds.slice(0, level));
                options = parent?.sublocations;
            }

            if (!options || options.length === 0) break;

            list.push({
                levelIndex: level,
                options,
            });

            if (!selectedIds[level]) break;
            level++;
        }

        return list;
    }, [roots, selectedIds]);

    // 🧹 Remove deeper levels when selecting a parent
    const handleSelect = (level, value) => {
        console.log("Correct level:", level, "value:", value);
        setSelectedIds((prev) => {
            const updated = [...prev];
            updated[level] = value;
            return updated.slice(0, level + 1);
        });
    };

    // 🔔 Notify only when deepest changes
    useEffect(() => {
        if (selectedIds.length < 3) return;

        const deepest = selectedIds[selectedIds.length - 1];
        if (deepest === lastReported.current) return;

        lastReported.current = deepest;
        onDeepestChange?.(deepest);
    }, [selectedIds]);

    return (
        <div>
            {levels.map((lvl) => (
                <div key={lvl.levelIndex} className="mt-2">
                    <label className="form-label" style={{ minHeight: "15px" }}>
                        {locationWord[lvl.levelIndex]}{" "}
                        {lvl.levelIndex < 3 && <span className="text-danger">*</span>}
                    </label>

                    <select
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        value={selectedIds[lvl.levelIndex] ?? ""}
                        onChange={(e) =>
                            handleSelect(lvl.levelIndex, e.target.value)
                        }
                    >
                        <option value="">-- Select --</option>
                        {lvl.options.map((loc) => (
                            <option key={loc.id} value={loc.id}>
                                {loc.location_name}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
}

export default LocationSelectChain;
